import { useParams } from 'react-router';

/**
 * Hook that provides absolute navigation paths based on current route parameters.
 * Uses URL params as source of truth instead of context to ensure paths are always in sync.
 */
export const useNavigationPaths = () => {
    const { propertyAssociationId, areaId } = useParams<{ propertyAssociationId: string; areaId: string }>();

    const paBase = `/${propertyAssociationId}`;
    const areaBase = `/${propertyAssociationId}/areas/${areaId}`;

    return {
        propertyAssociation: (id: string) => `/${id}/areas/`,
        area: (id: string, page: string = '') => `/${propertyAssociationId}/areas/${id}${page}`,

        // Routes that don't require area (directly under PA)
        members: `${paBase}/members`,
        messages: `${paBase}/messages`,
        settings: `${paBase}/settings`,

        // Asset routes (require area)
        assets: `${areaBase}/assets`,
        createAsset: `${areaBase}/assets/create`,
        viewAsset: (assetId: string) => `${areaBase}/assets/${assetId}`,
        editAsset: (assetId: string) => `${areaBase}/assets/${assetId}/edit`,
        assetOverview: (assetId: string) => `${areaBase}/assets/${assetId}/overview`,

        // Booking routes (require area)
        bookings: `${areaBase}/bookings`,
        bookingArchive: `${areaBase}/bookings/archive`,
        bookingStatistics: `${areaBase}/bookings/statistics`,
        newBooking: `${areaBase}/bookings/new`,
        newBookingForAsset: (assetId: string) => `${areaBase}/bookings/new/${assetId}`,

        // Advert routes (require area)
        adverts: `${areaBase}/adverts`,
    };
};
